import React, { useEffect, useState } from "react";
import "./Contact.scss";
import { getRequest } from "../../../http/axiosConfig/config";
import urls from "../../../http/endpoints/urls";
import { toast } from "react-toastify";
import ContactRow from "./ContactRow";
import ListLoader from "../../re-usables/loaders/ListLoader";

export default function Contact() {
  const [contacts, setContacts] = useState([]);
  const [loading, setLoading] = useState(false);

  const getContacts = async () => {
    try {
      setLoading(true);
      const res = await getRequest(
        urls.contactList(localStorage.getItem("userId"))
      );
      setContacts(res);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
      toast.error("Something went wrong...Try again.");
    }
  };

  useEffect(() => {
    getContacts();
  }, []);

  console.log(contacts);
  
  return (
    <div className="contact-us">
      {loading && (
        <div style={{ height: 300, overflow: "hidden" }}>
          <ListLoader />
        </div>
      )}
      {contacts.map((item) => (
        <ContactRow rowItem={item} />
      ))}
    </div>
  );
}
